import type { ApiBody, ApiQuery } from '../../../shared/api/contracts'
export function fetchIncomeSchedule(signal?: AbortSignal) { return apiGet<'GET /admin/incomes/schedule'>('/admin/incomes/schedule',signal) }
export function saveIncomeSchedule(body: ApiBody<'PUT /admin/incomes/schedule'>,signal?: AbortSignal) { return apiPut<'PUT /admin/incomes/schedule'>('/admin/incomes/schedule',body,signal) }
import type { Income } from '../../../shared/api/models'
import { apiGet, apiPost, apiPut, apiDelete } from './transport'
import { getApiWorkspaceId } from './workspaceState'

export async function fetchIncomes(params: ApiQuery<'GET /admin/incomes'>, signal?: AbortSignal) {
  const u = new URLSearchParams()
  u.set('limit', String(params.limit))
  u.set('offset', String(params.offset))
  if (params.dateFrom) u.set('dateFrom', String(params.dateFrom))
  if (params.dateTo) u.set('dateTo', String(params.dateTo))
  if (params.category) u.set('category', String(params.category))
  if (params.includeSummary) u.set('includeSummary', 'true')
  return apiGet<'GET /admin/incomes'>(`/admin/incomes?${u.toString()}`, signal)
}

export async function fetchIncome(id: string, signal?: AbortSignal) {
  return apiGet<'GET /admin/incomes/:id'>(`/admin/incomes/${encodeURIComponent(id)}`, signal)
}

export async function fetchAllIncomes(params: Omit<Parameters<typeof fetchIncomes>[0], 'limit' | 'offset'>, signal?: AbortSignal) {
  const items: Income[] = []
  const workspace = getApiWorkspaceId()
  for (let page = 0; page < 100; page += 1) {
    if (getApiWorkspaceId() !== workspace) throw new Error('Бюджет изменён. Обновите данные.')
    const response = await fetchIncomes({ ...params, limit: 200, offset: page * 200 }, signal)
    items.push(...response.items)
    if (response.items.length < 200) return { ok: true as const, items }
  }
  throw new Error('Слишком много поступлений. Выберите более короткий период.')
}

export async function createIncome(payload: ApiBody<'POST /admin/incomes'>, signal?: AbortSignal) {
  return apiPost<'POST /admin/incomes'>('/admin/incomes', payload, signal)
}

export async function updateIncome(
  incomeId: string,
  payload: ApiBody<'PUT /admin/incomes/:id'>, signal?: AbortSignal
) {
  return apiPut<'PUT /admin/incomes/:id'>(`/admin/incomes/${encodeURIComponent(incomeId)}`, payload, signal)
}

export async function deleteIncome(incomeId: string, signal?: AbortSignal) {
  return apiDelete<'DELETE /admin/incomes/:id'>(`/admin/incomes/${encodeURIComponent(incomeId)}`, signal)
}
